import React from 'react';
import {partial} from 'lodash';

const TxtItem = props => {
    const {text, size, styles, onSelect, h} = props;
    return (
        <div
            className={`digital-resource-lib-panel-txt-item ${size}`}
            onClick={partial(onSelect, {
                name: text,
                h,
                styles
            })}
            style={styles}
        >
            {text}
        </div>
    );
};

export default TxtItem;
